/*
    微信编译页面权限字典
*/
'use strict';
angular.module('weixinBtnServiceModule', [])
    . factory('wexinBtnService', ['trsHttpService', '$modal', '$q', function(trsHttpService, $modal, $q) {
        return {
        // 微信待编平台权限
            initWechatCompBtn: function() {
                var btnRights = {
                    240: {
                        'OPERDESC': '新建',
                        'OPERNAME': 'wechat.daibian.xinjian'
                    },
                    241: {
                        'OPERDESC': '编辑',
                        'OPERNAME': 'wechat.daibian.bianji'
                    },
                    242: {
                        'OPERDESC': '送审',
                        'OPERNAME': 'wechat.daibian.songshen'
                    },
                    243: {
                        'OPERDESC': '送签',
                        'OPERFUN': 'wechat.daibian.qianfa'
                    },
                    244: {
                        'OPERDESC': '发稿单',
                        'OPERNAME': 'wechat.daibian.fagaodan'
                    },
                    251: {
                        'OPERDESC': '废稿',
                        'OPERFUN': 'wechat.daibian.feigao'
                    },
                    252: {
                        'OPERDESC': '外发',
                        'OPERNAME': 'wechat.daibian.waifa'
                    },
                    253: {
                        'OPERDESC': '收藏',
                        'OPERNAME': 'wechat.daibian.shoucang'
                    },
                    856: {
                        'OPERDESC': '发送',
                        'OPERNAME': 'wechat.daibian.sendmessage'
                    }
                };
                return btnRights;
            },
            // 微信待审平台权限
            initWechatPenBtn: function() {
                var btnRights = {
                    256: {
                        'OPERDESC': '编辑',
                        'OPERNAME': 'wechat.daishen.bianji'
                    },
                    257: {
                        'OPERDESC': '送签',
                        'OPERNAME': 'wechat.daishen.qianfa'
                    },
                    258: {
                        'OPERDESC': '撤稿',
                        'OPERNAME': 'wechat.daishen.tuigao'
                    },
                    259: {
                        'OPERDESC': '发稿单',
                        'OPERNAME': 'wechat.daishen.fagaodan'
                    },
                    260: {
                        'OPERDESC': '外发',
                        'OPERNAME': 'wechat.daishen.waifa'
                    },
                    261: {
                        'OPERDESC': '收藏',
                        'OPERNAME': 'wechat.daishen.shoucang'
                    }, 
                    857: {
                        'OPERDESC': '发送',
                        'OPERNAME': 'wechat.daibian.sendmessage'
                    }
                };
                return btnRights;
            },
            // 微信已送签平台权限
            initWechatSignBtn: function() {
                var btnRights = {
                    262: {
                        'OPERDESC': '编辑',
                        'OPERNAME': 'wechat.yiqianfa.bianji'
                    },
                    263: {
                        'OPERDESC': '取消送签',
                        'OPERNAME': 'wechat.yiqianfa.chegao'
                    },
                    264: {
                        'OPERDESC': '外发',
                        'OPERNAME': 'wechat.yiqianfa.waifa'
                    },
                    265: {
                        'OPERDESC': '收藏',
                        'OPERNAME': 'wechat.yiqianfa.shoucang'
                    },
                    858: {
                        'OPERDESC': '发送',
                        'OPERNAME': 'wechat.yiqianfa.sendmessage'
                    }
                };
                return btnRights;
            },
            // 微信已送签平台群发功能
            massSend: function(items, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weixin/service/massSend/weixinMassSend_tpl.html',
                    windowClass: 'weixinMassSend',
                    backdrop: false,
                    controller: 'weixinMassSendController',
                    resolve: {
                        draftParams: function() {
                            return {
                                'items': items
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            showItems: function(items, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weixin/service/showMassSend/showMassSend_tpl.html',
                    windowClass: 'weixinMassSend',
                    backdrop: false,
                    controller: 'weixinShowMassSendController',
                    resolve: {
                        draftParams: function() {
                            return {
                                'items': items
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            }
        };
    }]);
